// 审批工单的展示词表 (2026-08-26 从 ApprovalList 抽出, 顶栏通知铃铛复用).
// 后端同一份映射在 internal/pkg/notify/approval.go (飞书卡片文案), 新增资源类型两处都要加.

/** 工单状态 → 中文名 + 标签样式. */
export const STATUS_LABEL: Record<string, { label: string; cls: string }> = {
    pending: { label: '待审批', cls: 'bg-amber-50 text-amber-700' },
    approved: { label: '已通过', cls: 'cap-on' },
    rejected: { label: '已驳回', cls: 'bg-rose-50 text-rose-700' },
    cancelled: { label: '已撤回', cls: 'bg-slate-100 text-slate-500' },
};

/** 通用变更工单的资源类型 → 中文名. targetType 不在表内 = 参数行审批 (targetType 为工艺框架 code). */
export const RESOURCE_LABEL: Record<string, string> = {
    material: '材料',
    material_sku: 'SKU',
    phys_value: '理化参数',
    dict: '字典',
    dict_category: '字典类目',
    category: '类别',
    device: '设备',
    cap_type: '工艺类型',
    gallery: '效果图',
    tool: '工具',
    tip: '小贴士',
    phys_schema: '材料模板',
    device_schema: '设备模板',
    sku_schema: 'SKU规格模板',
    device_ext_value: '设备动态值',
    process_arch: '工艺框架',
    param_schema: '参数模板',
    mm_group: '加工模式',
    mm_mode: '加工模式',
    mm_device_ref: '设备模式引用',
    // 审批全覆盖 (2026-08-14): Schema 字段字典 / 设备-材料适配 / 参数行硬删.
    schema_field: 'Schema字段',
    device_material_compat: '设备材料适配',
    param_row: '参数行',
    // 关联数据统一创建 (2026-08-20): 一个工单 = 主体 + 全部强关联子资源 (含参数行, 通过即发布)
    device_bundle: '设备套件',
    material_bundle: '材料套件',
    // 平台访问申请 (2026-08-25): 普通用户申请访问, 通过后 admin_user 行置 approved
    access_user: '平台访问',
    // API 令牌申请 (2026-09-28): 所有 scope 的令牌都要审批, 通过后 pending→active
    api_token: 'API 令牌',
};

/** 模块名: 命中资源表取中文名, 否则是参数行审批 (targetType 为工艺框架 code). */
export function moduleLabel(targetType: string): string {
    return RESOURCE_LABEL[targetType] || `参数 · ${targetType}`;
}

// 工单数变化的页内广播 (2026-08-26): 审批/撤回后顶栏铃铛要立刻重算徽标 ——
// 同一标签页内操作不触发 visibilitychange, 只靠 60s 轮询会让徽标停在旧数字上.
const APPROVAL_CHANGED = 'approval:changed';

/** 通知顶栏铃铛刷新 (approve / reject / 批量审批 / 撤回后调用). */
export function emitApprovalChanged(): void {
    window.dispatchEvent(new Event(APPROVAL_CHANGED));
}

/** 订阅工单变化, 返回退订函数. */
export function onApprovalChanged(fn: () => void): () => void {
    window.addEventListener(APPROVAL_CHANGED, fn);
    return () => window.removeEventListener(APPROVAL_CHANGED, fn);
}
